import {
  GET_CONVERTABLE_LIST,
  GET_CONVERTABLE_STATUS,
  GET_CONVERT_MOVIE_INFO,
  GET_UPLOAD_MOVIE_INFO,
  PAUSE_CONVERT_MOVIE,
  RQ_COMPANY_TOKEN,
  RQ_CONVERT_MOVIE,
  RQ_FILE_ID,
  SET_CONVERT_FILTER_TYPE,
  SET_DUBBED_FILE_PROPS,
  SET_FILE_PROPS,
  SET_SUBTITLE_FILE_PROPS,
} from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
  fileID: null,
  companyAccessToken: null,
  movieInfo: null,
  convertableList: [],
  metaConvertableList: {
    total_pages: 0,
    count_items_page: 0,
    current_page: 1,
    next_page: null,
    prev_page: null,
  },
  convertedMovie: {},
  fileProps: null,
  convertFilterType: {
    by_name: '',
    page: 1,
  },
  convertInfo: null,
  availableQualities: [],
  subtitleFileProps: null,
  dubbedFileProps: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CONVERT_FILTER_TYPE:
      return {
        ...state,
        convertFilterType: action.payload,
      };
    case GET_CONVERTABLE_LIST:
      return {
        ...state,
        convertableList: action.payload.movies,
        metaConvertableList: action.payload.meta,
      };
    case GET_UPLOAD_MOVIE_INFO:
      return {
        ...state,
        movieInfo: action.payload,
      };
    case RQ_CONVERT_MOVIE:
      return {
        ...state,
        relationsList: action.payload,
      };
    case GET_CONVERT_MOVIE_INFO:
      return {
        ...state,
        convertInfo: action.payload,
      };
    case RQ_COMPANY_TOKEN: {
      return {
        ...state,
        companyAccessToken: action.payload,
      };
    }
    case RQ_FILE_ID: {
      return {
        ...state,
        fileID: action.payload,
      };
    }
    case SET_FILE_PROPS: {
      return {
        ...state,
        fileProps: action.payload,
      };
    }
    case PAUSE_CONVERT_MOVIE: {
      return {
        ...state,
      };
    }
    case GET_CONVERTABLE_STATUS: {
      return {
        ...state,
        availableQualities: action.payload.data.qualityConvert,
      };
    }
    case SET_SUBTITLE_FILE_PROPS: {
      return {
        ...state,
        subtitleFileProps: action.payload
      };
    }
    case SET_DUBBED_FILE_PROPS: {
      return {
        ...state,
        dubbedFileProps: action.payload
      };
    }
    default:
      return state;
  }
};
